import { onMounted, onBeforeUnmount, nextTick } from 'vue';
import { gsap, ScrollTrigger } from '@/plugins/gsap';

const ALLOW_MOTION = '(prefers-reduced-motion: no-preference)';

// Runs `setup(root)` inside a gsap.matchMedia scope, but only when the visitor allows
// motion. Every tween and ScrollTrigger created in `setup` is reverted on unmount (or when
// the media query stops matching), so components never leak animations between routes.
// `setup` may return a cleanup function.
export function useMotion(rootRef, setup) {
  let mm;

  onMounted(async () => {
    await nextTick();
    const root = rootRef.value && (rootRef.value.$el || rootRef.value);
    if (!root) return;
    mm = gsap.matchMedia();
    mm.add(ALLOW_MOTION, () => setup(root), root);
    ScrollTrigger.refresh();
  });

  onBeforeUnmount(() => {
    if (mm) mm.revert();
  });
}
